import getPaginatedReports from './get-paginated-reports';

const asyncThunks = {
  getPaginatedReports,
};

export default asyncThunks;
